import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('product_data_project_list')
        .setAdditionalRoutes([
            'product_data_project_create',
            'product_data_project_edit',
        ]),
    MenuEntry.create()
        .setRoute('product_data_product_import_list')
        .setAdditionalRoutes([
            'product_data_product_import_create',
            'product_data_product_import_edit',
            'product_data_product_import_edit_core_data_only',
            'product_data_select_products',
        ]),
    MenuEntry.create()
        .setRoute('product_data_damaged_products')
        .setAdditionalRoutes([
            'product_data_damaged_products_edit',
        ]),
    MenuEntry.create()
        .setRoute('product_data_attribute')
        .setAdditionalRoutes([
            'product_data_attribute_create',
            'product_data_attribute_edit',
        ]),
    MenuEntry.create()
        .setRoute('product_data_attribute_group')
        .setAdditionalRoutes([
            'product_data_attribute_group_edit',
            'product_data_attribute_group_create',
        ]),
    MenuEntry.create()
        .setRoute('product_group_list')
        .setAdditionalRoutes([
            'product_group_create',
            'product_group_edit',
        ]),
    MenuEntry.create()
        .setRoute('product_kind_list')
        .setAdditionalRoutes([
            'product_kind_create',
            'product_kind_edit',
        ]),
    MenuEntry.create()
        .setRoute('product_data_reports_products_missing_show_in_shop'),

    MenuEntry.create()
        .setRoute('product_data_reports_products_missing_category'),

    MenuEntry.create()
        .setRoute('product_data_reports_media_reference_error'),

    MenuEntry.create()
        .setRoute('product_data_bulk_price_edit'),
    MenuEntry.create()
        .setRoute('shipment_product_group_overview')
        .setAdditionalRoutes([
            'shipment_product_group_create',
            'shipment_product_group_edit',
        ]),
    MenuEntry.create()
        .setRoute('shipment_product_group_products_without_group'),
    MenuEntry.create()
        .setRoute('reported_products_list')
        .setAdditionalRoutes([
            'reported_products_detail',
        ]),
    MenuEntry.create()
        .setRoute('product_list'),
];
